//adminUpdateSupportRequest.jsx

import axios from 'axios';
import React from 'react'
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';

const AdminUpdateSupportRequest = async({payload}) => {

   
        const data = new FormData();
        data.append("session", payload.session);
        data.append("status",payload.status);
        data.append("id", payload.id);
        if(payload.notification) data.append("notification", payload.notification);
        const res = await axios.post(
          `${ENDPOINT}admin-update-support-request.php`,
          data,
          SecurityHeaders
        );
    
     if(res){

        return res.data
     }
      
    
}

export default AdminUpdateSupportRequest